Boolean.prototype.toReadableString = function (trueText: string, falseText: string): string {
    return Boolean(this) === true ? trueText : falseText;
};

export {};
